import { getCurrentScope } from 'vue-demi';

export default function assertHasScope(message = 'Expected to have an active scope.') {
  if (!getCurrentScope()) {
    throw new Error(message);
  }
}
